import React from "react";
import { Tree } from "@ecologi/shared";
import styled from "@emotion/styled";
import {
  ForestTile,
  ForestTileProps,
  ForestTileInner,
  ForestTileStackPost,
  ForestTilePopover,
} from "../ForestTile";

type ForestTileBaseProps = ForestTileProps;

const ForestTileBase = styled(ForestTile)<ForestTileBaseProps>`
  cursor: pointer;

  // for svg graphic overlays of actual trees
  &::after {
    background-image: ${(props) => props.backgroundImage};
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    content: "";
    display: block;
    position: absolute;
    transform: scaleX(${(props) => (props.isFlipped ? "-1" : "1")});
  }
  @media ${(props) => props.theme.bp.tabletDown} {
    background-size: 90%;
  }
`;

export type ForestSubprofileTileProps = {
  isLinkedTile: boolean;
  isNudged: boolean;
  numbering: number;
  onClick: () => void;
  tree: Tree;
};

export const ForestSubprofileTile = ({
  isLinkedTile,
  isNudged,
  numbering,
  onClick,
  tree,
}: ForestSubprofileTileProps) => {
  const tileKeyName = "subProfileTile";
  const backgroundImage = `url(/images/app/forest/trees/${tileKeyName}.svg)`;

  return (
    <ForestTileBase
      id={isLinkedTile ? tree._id : ""}
      onClick={onClick}
      backgroundImage={backgroundImage}
      isFlipped={tree.style === "b" && !tree.isBirthday}
      isNudged={isNudged}
      $isCentered={numbering === 1}
      data-testid="tile"
    >
      <ForestTileInner>
        <ForestTileStackPost value={tree?.name?.slice(0, 30)} isCentered />
        {isLinkedTile && (
          <ForestTilePopover
            message={`Your tree${tree.value > 1 ? "s" : ""}`}
          />
        )}
      </ForestTileInner>
    </ForestTileBase>
  );
};
